class SpektrixIframe {
    constructor(element) {
        this.element = element;
        this.iframe = element.querySelector("iframe");
        this.uid = this.iframe.dataset.iframeUid;
        this.loadingIndicator = element.querySelector(
            ".spektrix-iframe__loading-indicator",
        );

        this.iframe.addEventListener("load", () => {
            this.loaded();
        });

        if (this.iframe.readyState === "complete") {
            this.loaded();
        }
    }

    loaded() {
        this.loadingIndicator &&
            this.loadingIndicator.setAttribute("active", false);
        this.iframe.classList.add("is-loaded");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".spektrix-iframe").forEach((element) => {
        new SpektrixIframe(element);
    });
});
